import './Diagram/Diagram.component.css'

import { Col, Grid, Row } from 'react-bootstrap'

import { DetailComponent } from './Details/Detail.component'
import { DiagramContainer } from './Diagram/DiagramContainer'
import LegendComponent from './Legend/Legend.component'
import PROXIMA1 from './Config/CamembertConfigurations/PROXIMA1.json'
import PROXIMA2A from './Config/CamembertConfigurations/PROXIMA2A.json'
import React from 'react'
import { connect } from 'react-redux'

// css

/**
 * Menu class which is used to render the app main top menu
 */
export class CamembertContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      sampleContainersIdsForSelectedBeamLineLocation: this.getAllSampleContainersIdsForSelectedBeamLineLocationCallback(
        props.selectedShipment.beamlineLocation
      ),
      selectedSampleContainer: this.props.filtered && this.props.filtered[0],
      samplesOfSelectedSampleContainer: null,
    }
    this.updateSelectedSampleContainerCallback = this.updateSelectedSampleContainerCallback.bind(this)
    this.updateSamplesOfSelectedSampleContainerCallback = this.updateSamplesOfSelectedSampleContainerCallback.bind(this)
  }

  CamembertConfigurations = {
    PROXIMA1: PROXIMA1,
    PROXIMA2A: PROXIMA2A,
  }

  updateSelectedSampleContainerCallback = selectedSampleContainer => {
    this.setState({
      selectedSampleContainer: selectedSampleContainer,
    })
  }

  updateSamplesOfSelectedSampleContainerCallback = samplesOfSelectedSampleContainer => {
    this.setState({
      samplesOfSelectedSampleContainer: samplesOfSelectedSampleContainer,
    })
  }

  getAllSampleContainersIdsForSelectedBeamLineLocationCallback = beamlineLocation =>
    this.props.filtered
      .filter(container => !!container.beamlineLocation)
      .filter(
        container =>
          container?.beamlineLocation
            .toString()
            .toLowerCase()
            .trim()
            .localeCompare(beamlineLocation?.toString().toLowerCase().trim()) === 0
      )
      .map(container => container.containerId)

  // FIXME bmo 20210210
  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps) {
    this.setState({
      sampleContainersIdsForSelectedBeamLineLocation: this.getAllSampleContainersIdsForSelectedBeamLineLocationCallback(
        nextProps.selectedShipment.beamlineLocation
      ),
    })
  }

  render() {
    const configuration = this.CamembertConfigurations[this.props.selectedShipment.beamlineLocation]
    return (
      <Grid fluid>
        <Row>
          <Col xs={7}>
            {configuration && (
              <DiagramContainer
                selectedSampleContainer={this.state.selectedSampleContainer}
                updateSamplesOfSelectedSampleContainerCallback={this.updateSamplesOfSelectedSampleContainerCallback}
                updateSelectedSampleContainerCallback={this.updateSelectedSampleContainerCallback}
                sampleContainersIdsForSelectedBeamLineLocation={
                  this.state.sampleContainersIdsForSelectedBeamLineLocation
                }
                fetchDataCallback={() => {
                  this.props.fetchDataCallback()
                }}
                user={this.props.user}
                username={this.props.user.username}
                selectedShipment={this.props.selectedShipment}
                configuration={configuration}
                containersInfo={this.props.filtered}
                beamlineLocation={this.props.selectedShipment.beamlineLocation}
                proposalName={this.props.proposalName}
              />
            )}
          </Col>
          <Col xs={5}>
            {configuration && this.props.selectedShipment.beamlineLocation && (
              <LegendComponent configuration={configuration} />
            )}
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            {configuration && this.props.selectedShipment.beamlineLocation && (
              <DetailComponent
                samplesOfSelectedSampleContainer={this.state.samplesOfSelectedSampleContainer}
                user={this.props.user}
                username={this.props.user.username}
                proposalName={this.props.proposalName}
                fetchDataCallback={() => {
                  this.props.fetchDataCallback()
                }}
                selectedShipment={this.props.selectedShipment}
                selectedSampleContainer={this.state.selectedSampleContainer}
                configuration={configuration}
                beamlineLocation={this.props.selectedShipment.beamlineLocation}
              />
            )}
          </Col>
        </Row>
      </Grid>
    )
  }
}

export default connect()(CamembertContainer)
